import { FEATURE_STATUS } from "features/Account/Account.constants";
import { getOptimisedS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";

export const CUSTOM_FEATURE_REQUEST_CONFIG = {
  // default fallback
  default: {
    text: {
      title: "Verification required to enable this feature.",
      color: "#033c4a",
    },
    backgroundColor: "#eef8ff",
    btn: {
      type: "submit",
      color: "#0f619c",
      btnText: "Request Verification",
    },
  },
  // to request
  [FEATURE_STATUS.ACCESS_LOCKED]: {
    text: {
      title: "Verification required to enable this feature.",
      color: "#033c4a",
    },
    backgroundColor: "#eef8ff",
    btn: {
      type: "submit",
      color: "#0f619c",
      btnText: "Request Verification",
    },
  },
  // requested
  [FEATURE_STATUS.ACCESS_REQUESTED]: {
    text: {
      title: "We'll update you as soon as the verification is complete.",
      color: "#473905",
    },
    backgroundColor: "#FFF7DA",
    btn: {
      color: "#473905",
      btnText: "Verification in progress...",
      className: "inProgressBtn",
      icon: getOptimisedS3AssetCDNUrl("Account/in_progress.png"),
    },
  },
  // failed
  [FEATURE_STATUS.ACCESS_DENIED]: {
    text: {
      title:
        "Verification has failed. Please try again or contact support for any queries.",
      color: "rgba(39, 37, 34, 0.80)",
    },
    backgroundColor: "#F2F2F2",
    btn: {
      type: "submit",
      color: "rgba(39, 37, 34, 0.85)",
      btnText: "Retry Verification",
    },
  },
  // granted
  [FEATURE_STATUS.ACCESS_GRANTED]: {
    text: {
      title:
        "Verification completed successfully! You can enable this feature now.",
      color: "#28a745",
    },
    backgroundColor: "#d4edda",
    btn: {
      hidden: true,
      type: "submit",
      color: "#28a745",
      btnText: "View Documents",
    },
  },
};
